import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { COMMON } from 'app/core/constants/common';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, ViewEncapsulation } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { InputGeneralComponent } from 'app/components/input-general/input-general.component';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { SelectGeneralApplicationComponent } from '../landing/corporate/select-general-application/select-general-application.component';
import { EncryptionService } from 'app/services/encryption.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-cgc-development-programme-form',
    templateUrl: './cgc-development-programme-form.component.html',
    styleUrls: ['./cgc-development-programme-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        MatRadioModule,
        FooterComponent,
        HeaderComponent,
        LoaderComponent,
        TranslateModule,
        ReactiveFormsModule,
        InputGeneralComponent,
        SelectGeneralApplicationComponent,
    ],
    standalone: true,
})
export class CgcDevelopmentProgrammeFormComponent {
    LNDForm: FormGroup;

    id: any;
    langURL: any;
    eventType: any;
    isRequired: any;
    eventTitle: any;
    emailInvalid: any;
    bizRegNoLimit: any;
    loggedInUserData: any;
    selectedLanguage: any;
    mobileNoDigitLimit: any;
    emailCharacterLimit: any;
    businessSectorValue: any;
    businessLocationValue: any;
    yearsInOperationValue: any;
    interestedPlatformValue: any;

    questionairs: any = [];
    businessSectorOption: any = [];
    yearsInOperationOption: any = [];
    businessLocationOption: any = [];
    interestedPlatformOption: any = [];

    submitted: boolean = false;
    isAuthenticated: boolean = false;
    submittedSuccessfully: boolean = false;
    toggleDropDown = [false, false, false];

    NETWORKING_SESSION: string = 'Networking Sessions';
    ACCESS_NEW_MARKETS: string = 'Access New Markets';

    constructor(
        public router: Router,
        private fb: FormBuilder,
        private snackBar: MatSnackBar,
        private translate: TranslateService,
        private activatedRoute: ActivatedRoute,
        private applicationService: ApplicationService,
        private encryptionService: EncryptionService,
        private toastr: ToastrService,
    ) {}

    ngOnInit() {
        /* GET LOGGED IN USER DATA */
        if (localStorage?.getItem('profile')) {
            const encryptionKey = atob(localStorage.getItem('cepn'));
            const userDataTemp = this.encryptionService.decryptData(
                localStorage.getItem('profile'),
                encryptionKey
            );
            let userData = userDataTemp === '' ? null : atob(userDataTemp);
            this.loggedInUserData = JSON.parse(userData);
        }

        /* GET EVENT TITLE */
        if (localStorage?.getItem('event_title')) {
            this.eventTitle = localStorage?.getItem('event_title');
        } else {
            this.eventTitle = '';
        }

        /* TO CHECK IF USER IS AUTHENTICATED */
        this.isAuthenticated =
            localStorage?.getItem('isAuthenticated') == 'true' ? true : false;

        /* GET PARAMETER OF ID */
        this.activatedRoute.queryParams.subscribe((params) => {
            this.id = Number(params.calendarEventId);

            if (params?.lang) {
                this.langURL = params?.lang;
                localStorage.setItem('language', this.langURL);
            }
        });

        /* GET INITIAL SELECTED LANGUAGE */
        if (this.isAuthenticated) {
            this.selectedLanguage = this.langURL
                ? this.langURL
                : localStorage?.getItem('language');
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    calendarEventURL: `/cgc-developmental-programme/registration?calendarEventId=${this.id}`,
                    lang: this.langURL,
                },
            });
        }

        this.LNDForm = this.fb.group({
            isCGCCustomer: [''],
            name: [
                this.loggedInUserData ? this.loggedInUserData?.username : '',
            ],
            companyName: [''],
            bizRegNo: [''],
            yearsInOperation: [''],
            businessLocation: [''],
            email: [this.loggedInUserData ? this.loggedInUserData?.email : ''],
            mobileNo: [
                this.loggedInUserData ? this.loggedInUserData?.phoneNumber : '',
            ],
            businessSector: [''],
            designation: [''],
            shareProducts: [''],
            platform: [''],
            // //workshop_source
        });

        this.translate.get('ERROR.IS_REQUIRED').subscribe((data: any) => {
            this.isRequired = data;
        });

        this.translate
            .get('ERROR.MAX_LENGTH_BUSINESSREG')
            .subscribe((data: any) => {
                this.bizRegNoLimit = data;
            });

        this.translate.get('ERROR.CONTACT_US_EMAIL').subscribe((data: any) => {
            this.emailInvalid = data;
        });

        this.translate
            .get('ERROR.MUST_NOT_BE_MORE_THAN_100_CHAR')
            .subscribe((data: any) => {
                this.emailCharacterLimit = data;
            });

        this.translate
            .get('ERROR.MUST_BE_MIN_6_OR_MAX_11_DIGITS')
            .subscribe((data: any) => {
                this.mobileNoDigitLimit = data;
            });
    }

    getQuestions(id: any) {
        let payload = {
            calender_id: id,
        };

        this.applicationService.getWorkshopQuestions(payload).subscribe({
            next: (x) => {
                this.questionairs = x;
                let initialQuestionList = this.questionairs[0];
                this.eventType = initialQuestionList.form_name;
                let formQuestVal;
                if (this.selectedLanguage == 'en') {
                    formQuestVal = initialQuestionList?.form_structure_en;
                } else {
                    formQuestVal = initialQuestionList?.form_structure_bm;
                }

                this.yearsInOperationOption = [];
                this.businessLocationOption = [];
                this.businessSectorOption = [];
                this.interestedPlatformOption = [];

                formQuestVal?.years_in_operation.forEach((e: any) => {
                    let obj = {
                        value: e,
                        label: e,
                    };
                    this.yearsInOperationOption.push(obj);
                });
                formQuestVal?.business_location.forEach((e: any) => {
                    let obj = {
                        value: e,
                        label: e,
                    };
                    this.businessLocationOption.push(obj);
                });
                formQuestVal?.business_sector.forEach((e: any) => {
                    let obj = {
                        value: e,
                        label: e,
                    };
                    this.businessSectorOption.push(obj);
                });
                if (formQuestVal?.platform) {
                    formQuestVal?.platform?.forEach((e: any) => {
                        let obj = {
                            value: e,
                            label: e,
                        };
                        this.interestedPlatformOption.push(obj);
                    });
                }
            },
            error: (err) => {
                this.toastr.error(err?.error?.message);
            },
        });
    }

    addValidators() {
        this.LNDForm.get('name').setValidators([Validators.required]);
        this.LNDForm.get('name').updateValueAndValidity();

        this.LNDForm.get('companyName').setValidators([Validators.required]);
        this.LNDForm.get('companyName').updateValueAndValidity();

        this.LNDForm.get('bizRegNo').setValidators([
            Validators.required,
            Validators.maxLength(COMMON.BUSINESS_REG_NO_MAX_LENGTH),
        ]);
        this.LNDForm.get('bizRegNo').updateValueAndValidity();

        this.LNDForm.get('yearsInOperation').setValidators([
            Validators.required,
        ]);
        this.LNDForm.get('yearsInOperation').updateValueAndValidity();

        this.LNDForm.get('businessLocation').setValidators([
            Validators.required,
        ]);
        this.LNDForm.get('businessLocation').updateValueAndValidity();

        this.LNDForm.get('email').setValidators([
            Validators.required,
            Validators.pattern(COMMON.EMAIL_PATTERN),
            Validators.maxLength(COMMON.EMAIL_MAX_LENGTH),
        ]);
        this.LNDForm.get('email').updateValueAndValidity();

        this.LNDForm.get('mobileNo').setValidators([
            Validators.required,
            Validators.minLength(COMMON.PHONE_NUMBER_MIN_LENGTH),
            Validators.maxLength(COMMON.PHONE_NUMBER_MAX_LENGTH),
        ]);
        this.LNDForm.get('mobileNo').updateValueAndValidity();

        this.LNDForm.get('businessSector').setValidators([Validators.required]);
        this.LNDForm.get('businessSector').updateValueAndValidity();

        if (this.eventType == 'Networking Sessions') {
            this.LNDForm.get('designation').setValidators([
                Validators.required,
            ]);
            this.LNDForm.get('designation').updateValueAndValidity();
        }

        if (this.eventType == 'Access New Markets') {
            this.LNDForm.get('platform').setValidators([Validators.required]);
            this.LNDForm.get('platform').updateValueAndValidity();
        }
    }

    removeValidators() {
        this.LNDForm.get('name').clearValidators();
        this.LNDForm.get('name').updateValueAndValidity();

        this.LNDForm.get('companyName').clearValidators();
        this.LNDForm.get('companyName').updateValueAndValidity();

        this.LNDForm.get('bizRegNo').clearValidators();
        this.LNDForm.get('bizRegNo').updateValueAndValidity();

        this.LNDForm.get('yearsInOperation').clearValidators();
        this.LNDForm.get('yearsInOperation').updateValueAndValidity();

        this.LNDForm.get('businessLocation').clearValidators();
        this.LNDForm.get('businessLocation').updateValueAndValidity();

        this.LNDForm.get('email').clearValidators();
        this.LNDForm.get('email').updateValueAndValidity();

        this.LNDForm.get('mobileNo').clearValidators();
        this.LNDForm.get('mobileNo').updateValueAndValidity();

        this.LNDForm.get('businessSector').clearValidators();
        this.LNDForm.get('businessSector').updateValueAndValidity();

        if (this.eventType == 'Networking Sessions') {
            this.LNDForm.get('designation').clearValidators();
            this.LNDForm.get('designation').updateValueAndValidity();
        }

        if (this.eventType == 'Access New Markets') {
            this.LNDForm.get('platform').clearValidators();
            this.LNDForm.get('platform').updateValueAndValidity();
        }
    }

    onLNDFormSubmit(event, data) {
        this.submitted = true;
        this.addValidators();
        this.updateTranslation();

        if (this.LNDForm.valid) {
            let filteredMob = this.LNDForm.value.mobileNo
                ?.replaceAll('(', '')
                .replaceAll(')', '')
                .replaceAll(' ', '');
            let payload = {
                calender_id: this.id,
                is_cgc_customer: 'true', //prefilled as requested by Aliyah & Nish
                name: this.LNDForm.value.name,
                company_name: this.LNDForm.value.companyName,
                business_registration: this.LNDForm.value.bizRegNo,
                years_in_operation: this.LNDForm.value.yearsInOperation,
                business_location: this.LNDForm.value.businessLocation,
                email: this.LNDForm.value.email,
                handphone_number: filteredMob,
                business_sector: this.LNDForm.value.businessSector,
                designation: this.LNDForm.value.designation
                    ? this.LNDForm.value.designation
                    : 'null',
                share: this.LNDForm.value.shareProducts
                    ? this.LNDForm.value.shareProducts
                    : 'null',
                platform: this.LNDForm.value.platform
                    ? this.LNDForm.value.platform
                    : 'null',
                workshop_source: 'Social Media',
            };

            this.applicationService.submitWorkshopQuestions(payload).subscribe({
                next: (x) => {
                    this.submittedSuccessfully = true;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    this.LNDForm.reset();
                    this.LNDForm.value.yearsInOperation = '';
                    this.LNDForm.value.businessLocation = '';
                    this.LNDForm.value.businessSector = '';
                    this.LNDForm.value.platform = '';
                    this.removeValidators();
                    localStorage.removeItem('event_title');
                    setTimeout((x) => {
                        this.router.navigate(['/cgc-developmental-programme'], {
                            queryParams: {
                                calendarEventId: this.id,
                            },
                        });
                        this.submittedSuccessfully = false;
                    }, 5000);
                },
                error: (err) => {
                    if (typeof err.error !== 'object') {
                        this.toastr.error(err.error);
                    } else {
                        let err_msg = err.error.error;
                        const err_msg_user_registered =
                            'User is already registered for this calendar.';
                        if (err_msg == err_msg_user_registered) {
                            this.showSnackBar(
                                'LND_FORM_QUESTION.ERROR_USER_REGISTERED_FOR_THIS_CALENDAR',
                                'COMMON.CLOSE'
                            );
                            setTimeout((x) => {
                                this.LNDForm.reset();
                                this.LNDForm.value.yearsInOperation = '';
                                this.LNDForm.value.businessLocation = '';
                                this.LNDForm.value.businessSector = '';
                                this.LNDForm.value.platform = '';
                                this.removeValidators();
                                this.router.navigate([
                                    '/cgc-developmental-programme',
                                ]);
                                this.submittedSuccessfully = false;
                            }, 2000);
                        }
                    }
                },
            });
        }
    }

    showSnackBar(msg, btn, className?, className2?) {
        let message: any = '';
        let button: any = '';
        this.translate.get(msg).subscribe((data: any) => {
            return (message = data);
        });

        this.translate.get(btn).subscribe((data: any) => {
            return (button = data);
        });

        return this.snackBar.open(message, button, {
            duration: 3000,
            panelClass: [className, className2],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
        });
    }

    updateTranslation() {
        this.translate.get('ERROR.IS_REQUIRED').subscribe((data: any) => {
            this.isRequired = data;
        });

        this.translate
            .get('ERROR.MAX_LENGTH_BUSINESSREG')
            .subscribe((data: any) => {
                this.bizRegNoLimit = data;
            });

        this.translate.get('ERROR.CONTACT_US_EMAIL').subscribe((data: any) => {
            this.emailInvalid = data;
        });

        this.translate
            .get('ERROR.MUST_NOT_BE_MORE_THAN_100_CHAR')
            .subscribe((data: any) => {
                this.emailCharacterLimit = data;
            });

        this.translate
            .get('ERROR.MUST_BE_MIN_6_OR_MAX_11_DIGITS')
            .subscribe((data: any) => {
                this.mobileNoDigitLimit = data;
            });
    }

    getErrors(input: any, inputName?: any): Array<any> {
        let errors = [];
        this.updateTranslation();
        if (this.submitted) {
            if (
                (input == 'name' ||
                    input == 'companyName' ||
                    input == 'bizRegNo' ||
                    input == 'yearsInOperation' ||
                    input == 'businessLocation' ||
                    input == 'email' ||
                    input == 'mobileNo' ||
                    input == 'businessSector' ||
                    input == 'designation' ||
                    input == 'platform') &&
                this.f[input].errors?.required
            ) {
                errors.push(inputName + ' ' + this.isRequired);
            }

            if (
                input == 'bizRegNo' &&
                this.f[input].errors?.maxlength &&
                !this.f[input].errors?.minlength
            ) {
                errors.push(inputName + ' ' + this.bizRegNoLimit);
            }

            if (
                input == 'email' &&
                this.f[input].errors?.pattern &&
                !this.f[input].errors?.maxlength
            ) {
                errors.push(this.emailInvalid);
            }

            if (input == 'email' && this.f[input].errors?.maxlength) {
                errors.push(inputName + ' ' + this.emailCharacterLimit);
            }

            if (
                input == 'mobileNo' &&
                (this.f[input].errors?.minlength ||
                    this.f[input].errors?.maxlength)
            ) {
                errors.push(inputName + ' ' + this.mobileNoDigitLimit);
            }
        }
        return errors;
    }

    handleInterestedPlatformOptions(value: any) {
        this.interestedPlatformValue = value;
        this.LNDForm.patchValue({
            platform: this.interestedPlatformValue,
        });
    }

    handleYearsInOperationOptions(value: any) {
        this.yearsInOperationValue = value;
        this.LNDForm.patchValue({
            yearsInOperation: this.yearsInOperationValue,
        });
    }

    handleBusinessLocationOptions(value: any) {
        this.businessLocationValue = value;
        this.LNDForm.patchValue({
            businessLocation: this.businessLocationValue,
        });
    }

    handleBusinessSectorOptions(value: any) {
        this.businessSectorValue = value;
        this.LNDForm.patchValue({
            businessSector: this.businessSectorValue,
        });
    }

    get f() {
        return this.LNDForm.controls;
    }

    closeDropdown() {
        for (let i = 0; i < 8; i++) {
            this.toggleDropDown[i] = false;
        }
    }

    closeAllDropdowns(state: number) {
        for (let i = 0; i < 8; i++) {
            if (i != state) {
                this.toggleDropDown[i] = false;
            } else {
                this.toggleDropDown[i] = true;
            }
        }
        event.stopPropagation();
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
        this.getQuestions(this.id);
    }

    alphabetOnly(e) {
        const inputValue = e.target.value;
        let val = '';
        val = inputValue.replace(/[^a-zA-Z ]/g, '');
        val = val === '' ? null : val;
        e.target.value = val;
    }

    alphaNumberOnly(e) {
        const inputValue = e.target.value;
        let val = '';
        val = inputValue.replace(/[^a-z0-9A-Z0-9 ]/g, '');
        val = val === '' ? null : val;
        e.target.value = val;
    }

    numberOnly(e) {
        const inputValue = e.target.value;
        let val = '';
        val = inputValue.replace(/[^0-9]/g, '');
        val = val === '' ? null : val;
        e.target.value = val;
    }

    keyPressNumbers(event) {
        const inputValue = event.target.value;
        let numericVal = '';
        numericVal = inputValue.replace(/\D/g, '');

        if (numericVal.length < 6) {
            numericVal = inputValue.replace(/\D/g, '');
        }

        if (numericVal.length >= 6) {
            if (numericVal.length >= 6 && numericVal.length < 10) {
                numericVal = inputValue.replace(
                    /(\d{1})(\d{3})(\d{2})/,
                    '+(6$1) $2 $3'
                );
            } else if (numericVal.length == 10) {
                numericVal = inputValue.replace(
                    /(\d{1})(\d{4})(\d{4})/,
                    '+(6$1) $2 $3'
                );
            } else if (numericVal.length > 10) {
                numericVal = inputValue
                    .replace(/\D/g, '')
                    .replace(/(\d{2})(\d{4})(\d{4})/, '+($1) $2 $3');
            }
        }

        /* CHECK IF NUMERICVAL INPUT HAVING ALPHABETS / SPECIAL CHARACTERS AFTER PATTERN */
        if (/[^a-zA-Z`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(numericVal)) {
            numericVal = numericVal.replace(
                /[A-Za-z`!@#$%^&*_\-=\[\]{};':"\\|,.<>\/?~]/,
                ''
            );
        }

        event.target.value = numericVal;
    }

    pasteNumberOnly(event) {
        let clipboardData = event.clipboardData;
        let pastedData = clipboardData.getData('Text');
        if (isNaN(pastedData)) {
            event.preventDefault();
        } else {
            return;
        }
    }
}
